import { api, unwrap } from "./httpClient";
import { Order } from "../types/api";

export interface SimulateTradePayload {
  userId: number;
  symbol: string;
  side: "BUY" | "SELL";
  quantity: number;
  orderId?: number;
  stopTriggerPrice?: number;
  executedPrice?: number;
  profitLossAmount?: number;
  description?: string;
}

/**
 * Crée un trade simulé pour un client
 * POST /api/v1/admin/trades/simulate
 */
export const simulateTrade = async (
  payload: SimulateTradePayload
): Promise<Order> => {
  return unwrap<Order>(
    api<Order>({
      method: "POST",
      url: "/admin/trades/simulate",
      data: payload,
    })
  );
};

export interface ClientLimitSummary {
  symbol: string;
  side: "BUY" | "SELL";
  totalQuantity: number;
  filledQuantity: number;
  remainingQuantity: number;
  minPrice: number | null;
  maxPrice: number | null;
}

export interface SimulationOpenOrder {
  id: number;
  symbol: string;
  side: "BUY" | "SELL";
  type: "LIMIT" | "STOP_LIMIT";
  price: number | null;
  stopPrice: number | null;
  quantity: number;
  filledQuantity: number;
  remainingQuantity: number;
  status: "pending" | "partially_filled";
}

/**
 * Récupère le résumé des ordres LIMIT d'un client (par paire et par côté)
 */
export const listClientLimitSummary = async (
  userId: number
): Promise<ClientLimitSummary[]> => {
  return unwrap<ClientLimitSummary[]>(
    api<ClientLimitSummary[]>({
      method: "GET",
      url: `/admin/trades/${userId}/limits`,
    })
  );
};

/**
 * Récupère les ordres LIMIT/STOP LIMIT ouverts d'un client (détail par ordre).
 */
export const listClientOpenOrdersForSimulation = async (
  userId: number
): Promise<SimulationOpenOrder[]> => {
  return unwrap<SimulationOpenOrder[]>(
    api<SimulationOpenOrder[]>({
      method: "GET",
      url: `/admin/trades/${userId}/open-orders`,
    })
  );
};
